export function TruncaFrac(valor: number, casas: number): number {
  let mult = 1;
  for (let i = 0; i < casas; i++) {
    mult *= 10;
  }
  return Math.trunc(valor * mult) / mult;
}
